(function ($) {
    $(document).ready(function () {

      $(document).on('click', '.cl-r-grid .js-r-wfx-collection__clear-filters:not(.active)', function() {
        $(this).addClass('active');
        $('.cl-r-grid li.filter-collection:not(.js-r-wfx-collection__clear-filters)').removeClass('active');
      });
    });

    $(document).on('click', '.cl-r-grid li.filter-collection:not(.js-r-wfx-collection__clear-filters)', function() {
        $('.cl-r-grid .js-r-wfx-collection__clear-filters').removeClass('active');
    });

})(jQuery);